import {PUBLIC_API_V1_BASE} from '../config/publicApi';

/** In-memory dedupe per tab (re-renders / strict mode). */
const notifyRequested = new Set();

export function parseFormSubmitNotifyPayload(emailResponse, parsedJson = null) {
    let body = parsedJson;
    if (body == null && emailResponse?.text) {
        try {
            body = JSON.parse(emailResponse.text);
        } catch {
            body = null;
        }
    }

    const ok = emailResponse?.status === 200 || Number(body?.status) === 200;
    if (!ok || !body) {
        return null;
    }

    const formType = String(body.formType || '').trim().toLowerCase();
    const senderName = String(body.senderName || '').trim();
    const entityId = String(body.entityId ?? '').trim();
    const referenceCode = String(body.referenceCode ?? entityId).trim();

    if (!formType || !senderName || !entityId) {
        return null;
    }

    return {formType, senderName, referenceCode, entityId};
}

/**
 * Fire-and-forget admin notify (no DB on server). Call from success/result page.
 */
export function requestFormAdminNotify(payload) {
    if (!payload?.formType || !payload?.senderName || !payload?.entityId) {
        return;
    }

    const key = `${payload.formType}:${payload.entityId}`;
    if (notifyRequested.has(key)) {
        return;
    }
    notifyRequested.add(key);

    void fetch(`${PUBLIC_API_V1_BASE}/form/notify-admin`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            formType: payload.formType,
            senderName: payload.senderName,
            referenceCode: payload.referenceCode || payload.entityId,
            entityId: String(payload.entityId),
        }),
        keepalive: true,
    }).catch(() => {});
}
